import styles from "./Loader.module.css";

function Loader() {
  return <div className={styles.loader} />;
}

export default Loader;
